import React from 'react';

const EngageButtons = (props) => <div className="engage_buttons">{props.children}</div>;

export default EngageButtons;